import React from 'react'

import { Typography, Box } from '@the-platform-group/component-library'
import { Grid } from '@the-platform-group/component-library/Layout'
import { Button } from '@the-platform-group/component-library/Button'
import { Lock as LockIcon } from '@the-platform-group/component-library/Icons'

import { AUTH_ERROR_TYPES } from 'constants/errorCodes'

/**
 * Displays a locked account error page with a logout action
 * @returns {React.ReactElement} The locked account display
 */
function IdentityLockedDisplay() {
  return (
    <Box sx={{ height: '100vh', width: '100%' }}>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        direction="column"
        spacing={2}
        sx={{ height: '100%' }}
      >
        <Grid item>
          <LockIcon color="error" sx={{ fontSize: '60px' }} />
        </Grid>
        <Grid item>
          <Typography variant="h5">Your Account Has Been Locked</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            Your account has been locked. Please contact your administrator or support team for
            assistance.
          </Typography>
        </Grid>
        <Grid item>
          <Button
            onClick={() => {
              window.location.href = '/logout'
            }}
          >
            Logout
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

/**
 * Error boundary for authentication-related errors from the API.
 * Handles identity_locked 401 errors that should display a dedicated
 * error page instead of triggering re-authentication.
 */
class AuthenticationErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { errorType: '' }
  }

  static getDerivedStateFromError(error) {
    if (error.response && error.response.data) {
      const { status, data } = error.response
      if (status === 401 && data.errors?.some(e => e.code === AUTH_ERROR_TYPES.identityLocked)) {
        return { errorType: AUTH_ERROR_TYPES.identityLocked }
      }
    }

    throw error
  }

  render() {
    switch (this.state.errorType) {
      case AUTH_ERROR_TYPES.identityLocked:
        return <IdentityLockedDisplay />
      default:
        return this.props.children
    }
  }
}

export default AuthenticationErrorBoundary
